import React from 'react';
import Hero from '../components/Hero';
import ProblemSection from '../components/ProblemSection';
import CapabilitiesSection from '../components/CapabilitiesSection';
import StreamsSection from '../components/StreamsSection';
import InstitutionSection from '../components/InstitutionSection';
import TrustSection from '../components/TrustSection';
import CredibilitySection from '../components/CredibilitySection';

const HomePage = () => {
  return (
    <>
      <Hero />
      <ProblemSection />
      <CapabilitiesSection />
      <StreamsSection />
      <InstitutionSection />
      <TrustSection />
      <CredibilitySection />
    </>
  );
};

export default HomePage;
